import { createPortal } from 'react-dom';

function Portal(props) {
  const { date, room, col, row, children } = props;
  let className = `tb_other_${date}_${room}_${col}_${row}`;
  className = `tb_other_${date}_${room}`;

  const portalRoot = document.getElementsByClassName(className);
  return createPortal(children, portalRoot[0]);
}

export default Portal;
